export default {
  // Navigation
  'nav.home': 'الرئيسية',
  'nav.solutions': 'الحلول',
  'nav.platform': 'المنصة',
  'nav.about': 'من نحن',
  'nav.contact': 'اتصل بنا',
  'nav.login': 'تسجيل دخول العملاء',
  
  // Hero Section
  'hero.title': 'تمكين الرعاية الصحية من خلال الحلول الرقمية الذكية',
  'hero.subtitle': 'توفر Guangbao-Uni منصات شاملة لإدارة الرعاية الصحية وخدمات تفاعل البيانات الضخمة للمؤسسات الطبية في جميع أنحاء العالم، مما يمكنها من تقديم رعاية متميزة لمرضاها',
  'hero.cta.demo': 'طلب عرض توضيحي',
  'hero.cta.learn': 'اعرف المزيد',
  
  // Solutions
  'solutions.title': 'حلول رعاية صحية شاملة',
  'solutions.subtitle': 'منصات متكاملة مصممة لتحويل تقديم الرعاية الصحية',
  'solutions.industry.title': 'منصة إدارة تطبيقات الصناعة',
  'solutions.industry.desc': 'تبسيط العمليات من خلال نظام الإدارة الشامل الخاص بالصناعة المصمم لمقدمي الرعاية الصحية',
  'solutions.health.title': 'منصة الصحة المتكاملة',
  'solutions.health.desc': 'حل إدارة صحية موحد يربط المؤسسات الطبية بالمرضى لتقديم رعاية سلسة',
  'solutions.enterprise.title': 'منصة إدارة المؤسسات',
  'solutions.enterprise.desc': 'منصة قوية على مستوى المؤسسات لإدارة العمليات وسير العمل الصحي المعقد',
  
  // Features
  'features.title': 'قدرات المنصة',
  'features.subtitle': 'ميزات متقدمة لتعزيز تقديم الرعاية الصحية',
  'features.data.title': 'تحليلات البيانات الطبية الضخمة',
  'features.data.desc': 'استفد من تحليلات البيانات القوية للحصول على رؤى وتحسين نتائج المرضى',
  'features.integration.title': 'التكامل السلس',
  'features.integration.desc': 'الاتصال بالأنظمة الحالية والخدمات الخارجية بسهولة',
  'features.security.title': 'أمان المؤسسات',
  'features.security.desc': 'بروتوكولات أمان على مستوى البنوك لحماية البيانات الطبية الحساسة',
  'features.scalability.title': 'قابلية التوسع العالمية',
  'features.scalability.desc': 'بنية تحتية سحابية تدعم المؤسسات الصحية في جميع أنحاء العالم',
  'features.compliance.title': 'الامتثال التنظيمي',
  'features.compliance.desc': 'تلبية المعايير واللوائح الصحية الدولية',
  'features.support.title': 'دعم على مدار الساعة',
  'features.support.desc': 'دعم فني على مدار الساعة لخدمة متواصلة',
  
  // Benefits
  'benefits.title': 'لماذا تختار Guangbao-Uni',
  'benefits.subtitle': 'حوّل مؤسستك الصحية بحلولنا المثبتة',
  'benefits.efficiency.title': 'تحسين الكفاءة',
  'benefits.efficiency.desc': 'أتمتة سير العمل وتقليل العبء الإداري بنسبة تصل إلى 60٪',
  'benefits.patient.title': 'تعزيز رعاية المرضى',
  'benefits.patient.desc': 'توفير تجارب أفضل للمرضى من خلال إدارة صحية متكاملة',
  'benefits.insights.title': 'رؤى مدفوعة بالبيانات',
  'benefits.insights.desc': 'اتخذ قرارات مستنيرة مع التحليلات والتقارير الشاملة',
  'benefits.cost.title': 'خفض التكاليف',
  'benefits.cost.desc': 'تحسين تخصيص الموارد وتقليل التكاليف التشغيلية بشكل كبير',
  
  // Stats
  'stats.institutions': 'المؤسسات الطبية',
  'stats.countries': 'الدول المخدومة',
  'stats.patients': 'المرضى المُدارون',
  'stats.uptime': 'وقت تشغيل النظام',
  
  // CTA
  'cta.title': 'هل أنت مستعد لتحويل مؤسستك الصحية؟',
  'cta.subtitle': 'انضم إلى المؤسسات الطبية الرائدة في جميع أنحاء العالم التي تستخدم منصات Guangbao-Uni',
  'cta.button': 'ابدأ اليوم',
  
  // Footer
  'footer.company': 'الشركة',
  'footer.about': 'من نحن',
  'footer.careers': 'الوظائف',
  'footer.news': 'الأخبار',
  'footer.products': 'المنتجات',
  'footer.industry': 'منصة الصناعة',
  'footer.health': 'منصة الصحة',
  'footer.enterprise': 'منصة المؤسسات',
  'footer.resources': 'الموارد',
  'footer.documentation': 'التوثيق',
  'footer.support': 'مركز الدعم',
  'footer.blog': 'المدونة',
  'footer.legal': 'قانوني',
  'footer.privacy': 'سياسة الخصوصية',
  'footer.terms': 'شروط الخدمة',
  'footer.security': 'الأمان',
  'footer.rights': '© 2024 Guangbao-Uni. جميع الحقوق محفوظة.',
  'footer.description': 'المزود الرائد لحلول الرعاية الصحية الذكية وخدمات البيانات الضخمة للمؤسسات الطبية في جميع أنحاء العالم.',
  
  // Contact
  'contact.title': 'تواصل معنا',
  'contact.subtitle': 'فريقنا جاهز لمساعدتك في تحويل عملياتك الصحية',
  'contact.name': 'الاسم الكامل',
  'contact.email': 'البريد الإلكتروني',
  'contact.company': 'اسم المؤسسة',
  'contact.phone': 'رقم الهاتف',
  'contact.message': 'الرسالة',
  'contact.submit': 'إرسال الرسالة',
  'contact.success': 'شكراً لك! سنتواصل معك قريباً.',
  
  // Login
  'login.title': 'تسجيل الدخول إلى بوابة العملاء',
  'login.subtitle': 'الوصول إلى منصة إدارة الرعاية الصحية الخاصة بك',
  'login.email': 'البريد الإلكتروني',
  'login.password': 'كلمة المرور',
  'login.remember': 'تذكرني',
  'login.forgot': 'نسيت كلمة المرور؟',
  'login.button': 'تسجيل الدخول',
  'login.support': 'تحتاج مساعدة؟ اتصل بالدعم',

  // Industry Platform
  'industryPlatform.hero.title': 'منصة إدارة تطبيقات الصناعة',
  'industryPlatform.hero.subtitle': 'حل شامل لإدارة صناعة الرعاية الصحية مع تحليلات بيانات متقدمة وأتمتة سير العمل وقدرات الامتثال التنظيمي',
  'industryPlatform.hero.exploreFeatures': 'استكشف الميزات',
  'industryPlatform.hero.contactUs': 'اتصل بنا',
  'industryPlatform.features.title': 'الميزات الأساسية',
  'industryPlatform.features.subtitle': 'أدوات قوية مصممة لإدارة صناعة الرعاية الصحية',
  'industryPlatform.features.dataManagement.title': 'إدارة البيانات الطبية',
  'industryPlatform.features.dataManagement.desc': 'تخزين وإدارة البيانات الطبية المركزية مع قدرات بحث واسترجاع متقدمة',
  'industryPlatform.features.analytics.title': 'التحليلات المتقدمة',
  'industryPlatform.features.analytics.desc': 'تحليلات وتقارير في الوقت الفعلي لاتخاذ قرارات مبنية على البيانات',
  'industryPlatform.features.compliance.title': 'إدارة الامتثال',
  'industryPlatform.features.compliance.desc': 'ضمان الالتزام بلوائح الرعاية الصحية ومعايير الصناعة',
  'industryPlatform.features.collaboration.title': 'التعاون متعدد المؤسسات',
  'industryPlatform.features.collaboration.desc': 'أدوات تعاون سلسة لشبكات وشراكات الرعاية الصحية',
  'industryPlatform.features.customization.title': 'التخصيص المرن',
  'industryPlatform.features.customization.desc': 'تخصيص المنصة وفقاً لمتطلبات صناعتك المحددة',
  'industryPlatform.features.cloudBased.title': 'البنية التحتية السحابية',
  'industryPlatform.features.cloudBased.desc': 'بنية سحابية آمنة وقابلة للتوسع لإمكانية الوصول العالمية',
  'industryPlatform.benefits.title': 'فوائد المنصة',
  'industryPlatform.benefits.subtitle': 'تحسينات قابلة للقياس لعمليات الرعاية الصحية الخاصة بك',
  'industryPlatform.benefits.efficiency.title': 'الكفاءة التشغيلية',
  'industryPlatform.benefits.efficiency.desc': 'تبسيط العمليات وتعزيز الإنتاجية في جميع أنحاء مؤسستك',
  'industryPlatform.benefits.efficiency.label': 'زيادة الكفاءة',
  'industryPlatform.benefits.accuracy.title': 'دقة البيانات',
  'industryPlatform.benefits.accuracy.desc': 'تقليل الأخطاء من خلال التحقق الآلي وضوابط الجودة',
  'industryPlatform.benefits.accuracy.label': 'دقة البيانات',
  'industryPlatform.benefits.cost.title': 'توفير التكاليف',
  'industryPlatform.benefits.cost.desc': 'تقليل التكاليف التشغيلية من خلال الأتمتة والتحسين',
  'industryPlatform.benefits.cost.label': 'خفض التكاليف',
  'industryPlatform.cta.title': 'حوّل عمليات الرعاية الصحية الخاصة بك',
  'industryPlatform.cta.subtitle': 'اكتشف كيف يمكن لمنصتنا إحداث ثورة في إدارة صناعتك',
  'industryPlatform.cta.button': 'جدولة عرض توضيحي',

  // Health Platform
  'healthPlatform.hero.title': 'منصة الصحة المتكاملة',
  'healthPlatform.hero.subtitle': 'حل إدارة رعاية صحية موحد يربط المؤسسات الطبية بالمرضى لتقديم رعاية سلسة وتحسين النتائج الصحية',
  'healthPlatform.hero.exploreFeatures': 'استكشف الميزات',
  'healthPlatform.hero.contactUs': 'اتصل بنا',
  'healthPlatform.features.title': 'ميزات المنصة',
  'healthPlatform.features.subtitle': 'أدوات شاملة لإدارة الصحة المتكاملة',
  'healthPlatform.features.patientManagement.title': 'إدارة المرضى',
  'healthPlatform.features.patientManagement.desc': 'إدارة كاملة لمعلومات المرضى مع سجلات صحية موحدة',
  'healthPlatform.features.appointment.title': 'جدولة المواعيد',
  'healthPlatform.features.appointment.desc': 'نظام جدولة ذكي لإدارة المواعيد بكفاءة',
  'healthPlatform.features.telemedicine.title': 'خدمات الطب عن بعد',
  'healthPlatform.features.telemedicine.desc': 'قدرات الاستشارة عن بعد وتقديم الرعاية الافتراضية',
  'healthPlatform.features.ehr.title': 'السجلات الصحية الإلكترونية',
  'healthPlatform.features.ehr.desc': 'سجلات صحية رقمية آمنة وشاملة يمكن الوصول إليها في أي وقت',
  'healthPlatform.features.prescription.title': 'الوصفات الإلكترونية',
  'healthPlatform.features.prescription.desc': 'إدارة الوصفات الرقمية والتكامل مع الصيدليات',
  'healthPlatform.features.monitoring.title': 'مراقبة الصحة',
  'healthPlatform.features.monitoring.desc': 'مراقبة مستمرة لصحة المرضى والتنبيهات',
  'healthPlatform.benefits.title': 'فوائد رعاية المرضى',
  'healthPlatform.benefits.subtitle': 'تقديم تجارب رعاية صحية متميزة',
  'healthPlatform.benefits.patientSatisfaction.title': 'رضا المرضى',
  'healthPlatform.benefits.patientSatisfaction.desc': 'تجربة محسّنة للمرضى من خلال تنسيق الرعاية السلس',
  'healthPlatform.benefits.patientSatisfaction.label': 'معدل الرضا',
  'healthPlatform.benefits.accessibility.title': 'الوصول إلى الرعاية الصحية',
  'healthPlatform.benefits.accessibility.desc': 'الوصول على مدار الساعة إلى خدمات ومعلومات الرعاية الصحية',
  'healthPlatform.benefits.accessibility.label': 'التوفر',
  'healthPlatform.benefits.waitTime.title': 'تقليل أوقات الانتظار',
  'healthPlatform.benefits.waitTime.desc': 'الجدولة المحسّنة تقلل أوقات انتظار المرضى بشكل كبير',
  'healthPlatform.benefits.waitTime.label': 'تقليل الوقت',
  'healthPlatform.cta.title': 'ارتقِ برعاية مرضاك',
  'healthPlatform.cta.subtitle': 'انضم إلى المؤسسات الصحية التي تقدم تجارب استثنائية للمرضى',
  'healthPlatform.cta.button': 'ابدأ الآن',

  // Enterprise Platform
  'enterprisePlatform.hero.title': 'منصة إدارة المؤسسات',
  'enterprisePlatform.hero.subtitle': 'منصة قوية على مستوى المؤسسات لإدارة العمليات والموارد وسير العمل الصحي المعقد مع ذكاء أعمال شامل',
  'enterprisePlatform.hero.exploreFeatures': 'استكشف الميزات',
  'enterprisePlatform.hero.contactUs': 'اتصل بنا',
  'enterprisePlatform.features.title': 'ميزات المؤسسات',
  'enterprisePlatform.features.subtitle': 'إدارة أعمال كاملة لمؤسسات الرعاية الصحية',
  'enterprisePlatform.features.orgManagement.title': 'إدارة المؤسسة',
  'enterprisePlatform.features.orgManagement.desc': 'هيكل تنظيمي هرمي وإدارة الأقسام',
  'enterprisePlatform.features.financial.title': 'الإدارة المالية',
  'enterprisePlatform.features.financial.desc': 'التخطيط المالي الشامل والميزانية وإعداد التقارير',
  'enterprisePlatform.features.hr.title': 'الموارد البشرية',
  'enterprisePlatform.features.hr.desc': 'إدارة كاملة للموارد البشرية بما في ذلك التوظيف والجدولة والأداء',
  'enterprisePlatform.features.reporting.title': 'ذكاء الأعمال',
  'enterprisePlatform.features.reporting.desc': 'تقارير وتحليلات متقدمة لاتخاذ القرارات الاستراتيجية',
  'enterprisePlatform.features.workflow.title': 'أتمتة سير العمل',
  'enterprisePlatform.features.workflow.desc': 'أتمتة العمليات التجارية المعقدة وسير عمل الموافقات',
  'enterprisePlatform.features.security.title': 'أمان المؤسسات',
  'enterprisePlatform.features.security.desc': 'أمان متعدد الطبقات مع التحكم في الوصول على أساس الأدوار',
  'enterprisePlatform.benefits.title': 'فوائد المؤسسات',
  'enterprisePlatform.benefits.subtitle': 'قيادة التميز والنمو في الأعمال',
  'enterprisePlatform.benefits.productivity.title': 'إنتاجية الفريق',
  'enterprisePlatform.benefits.productivity.desc': 'تمكين الفرق بأدوات فعالة وسير عمل آلي',
  'enterprisePlatform.benefits.productivity.label': 'تعزيز الإنتاجية',
  'enterprisePlatform.benefits.integration.title': 'تكامل الأنظمة',
  'enterprisePlatform.benefits.integration.desc': 'الاتصال بأنظمة المؤسسات الحالية والخدمات الخارجية',
  'enterprisePlatform.benefits.integration.label': 'التكاملات',
  'enterprisePlatform.benefits.roi.title': 'العائد على الاستثمار',
  'enterprisePlatform.benefits.roi.desc': 'تعظيم العائد على الاستثمار من خلال التميز التشغيلي وتحسين التكاليف',
  'enterprisePlatform.benefits.roi.label': 'زيادة العائد',
  'enterprisePlatform.cta.title': 'حسّن مؤسستك',
  'enterprisePlatform.cta.subtitle': 'اختبر قوة إدارة المؤسسات المتكاملة',
  'enterprisePlatform.cta.button': 'طلب استشارة',
};